<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<!-- Creator: CorelDRAW 2020 (64-Bit) -->
<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 3598.32 3598.32"
 xmlns:xlink="http://www.w3.org/1999/xlink"
 xmlns:xodm="http://www.corel.com/coreldraw/odm/2003">
 <defs>
  <style type="text/css">
   <![CDATA[
    .fil0 {fill:black;fill-rule:nonzero}
   ]]>
  </style>
 </defs>
 <g id="Layer_x0020_1">
  <metadata id="CorelCorpID_0Corel-Layer"/>
  <g>
   <path class="fil0" d="M2681.08 1799.19l0 -1587.52c0,-97.4 -78.99,-176.4 -176.39,-176.4l-2293.06 0.07c-97.33,-0.07 -176.33,78.93 -176.33,176.33l0 2469.45 705.53 -705.53 1763.86 0c97.4,-0.06 176.39,-79.06 176.39,-176.4l0 0zm705.6 -1058.32l-352.8 0 0 1587.52 -2293.05 0 0 352.73c0.07,97.33 79.07,176.33 176.47,176.33l1940.18 0.07 705.53 705.53 0 -2645.78c0.07,-97.4 -78.93,-176.4 -176.33,-176.4z"/>
  </g>
 </g>
</svg>
